import { Link } from "react-router-dom";
import { Info } from "lucide-react";

const ObrigadoAlt = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-lg text-center">
        <Info className="w-16 h-16 text-primary mx-auto mb-6" />
        
        <h1 className="text-3xl md:text-4xl font-display font-normal mb-4 text-foreground">
          Obrigado pelo seu interesse!
        </h1>
        
        <p className="text-base md:text-lg text-muted-foreground font-body leading-relaxed mb-8">
          Agradecemos por preencher o formulário. No momento, nosso serviço de diagnóstico 
          patrimonial está focado em perfis específicos, mas continuaremos trabalhando para 
          ampliar nosso alcance. Fique à vontade para conhecer mais sobre a Allu Capital.
        </p>
        
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-full text-sm font-medium transition-all hover:bg-primary/90"
        >
          Conhecer a Allu Capital
        </Link>
      </div>
    </div>
  );
};

export default ObrigadoAlt;
